module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../node_modules/happypack/loader.js?id=jsx!./ProductListView.js"));
	}, "productListView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=productListView!./src/pages/ProductList/ProductListView.js
// module id = ./node_modules/bundle-loader/index.js?lazy&name=productListView!./src/pages/ProductList/ProductListView.js
// module chunks = 43